export const DND_UPLOAD_START = "DND_UPLOAD_START";
export const DND_UPLOAD_PROGRESS = "DND_UPLOAD_PROGRESS";
export const DND_UPLOAD_COMPLETE = "DND_UPLOAD_COMPLETE";
export const DND_UPLOAD_FAIL = "DND_UPLOAD_FAIL";
export const DND_UPLOAD_DISMISS = "DND_UPLOAD_DISMISS";
export const DND_UPLOAD_DISMISS_ALL_COMPLETED =
  "DND_UPLOAD_DISMISS_ALL_COMPLETED";

export type DndUploadStatus = "uploading" | "success" | "error";

export type DndUploadSource = "editor-canvas" | "editor-sidebar" | "image-list";

export interface DndUploadEntry {
  uploadId: string;
  fileName: string;
  progress: number;
  startedAt: number;
  // Timestamp of the first non-zero progress event. Used as the ETA baseline
  // so compression / presign latency before the XHR starts doesn't inflate the
  // remaining-time estimate.
  firstProgressAt?: number;
  completedAt?: number;
  status: DndUploadStatus;
  source: DndUploadSource;
  errorMessage?: string;
}

export type DndUploadProgressState = Record<string, DndUploadEntry>;

export interface DndUploadStartAction {
  type: typeof DND_UPLOAD_START;
  uploadId: string;
  fileName: string;
  source: DndUploadSource;
  startedAt: number;
}

export interface DndUploadProgressAction {
  type: typeof DND_UPLOAD_PROGRESS;
  uploadId: string;
  progress: number;
}

export interface DndUploadCompleteAction {
  type: typeof DND_UPLOAD_COMPLETE;
  uploadId: string;
  completedAt: number;
}

export interface DndUploadFailAction {
  type: typeof DND_UPLOAD_FAIL;
  uploadId: string;
  errorMessage?: string;
  completedAt: number;
}

export interface DndUploadDismissAction {
  type: typeof DND_UPLOAD_DISMISS;
  uploadId: string;
}

export interface DndUploadDismissAllCompletedAction {
  type: typeof DND_UPLOAD_DISMISS_ALL_COMPLETED;
}

export type DndUploadProgressAnyAction =
  | DndUploadStartAction
  | DndUploadProgressAction
  | DndUploadCompleteAction
  | DndUploadFailAction
  | DndUploadDismissAction
  | DndUploadDismissAllCompletedAction;
